import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { FAQS } from "@/lib/site";

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative z-10 bg-surface border-y border-champagne py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid lg:grid-cols-[0.4fr_0.6fr] gap-12 lg:gap-20">
        <div>
          <SectionLabel>Questions</SectionLabel>
          <Reveal>
            <h2 className="font-serif font-light tracking-tight leading-[1.05] text-4xl md:text-5xl text-[color:var(--relumia-ink)]">
              Everything you want to know.
            </h2>
          </Reveal>
        </div>

        <div>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[color:var(--relumia-ink)]/12"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-serif text-xl md:text-2xl font-normal text-[color:var(--relumia-ink)] hover:no-underline hover:text-gold py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[14.5px] leading-relaxed text-[color:var(--relumia-muted)] pb-6 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
